import { Injectable } from '@angular/core';
import { ApiService } from '../utilities/api.service';

@Injectable({
    providedIn: 'root',
})
export class CommonApiService {
    constructor(public _apiService: ApiService) { }
    async generateCaptcha(type: any): Promise<any> {
        try {
            if (typeof window != 'undefined') {
                const data = {
                    "module": "captcha",
                    "action": "generateCaptcha",
                    "data": {
                        "type": type
                    }
                };
                return this._apiService.postApiDataWithEvents("productData/services", data);
            }
        } catch (error) {
            return error
        }
    }

}
